/**
 * Border colors aligned with Enterprise benefit / outcomes cards (Figma).
 * Unknown `themeColor` values fall back to a translucent mix so new LPs get a sensible default.
 */
const THEME_BORDER_BY_HEX: Record<string, string> = {
  '#00298c': 'rgba(123, 162, 255, 0.5)',
  '#c35000': 'rgba(255, 109, 0, 0.1)',
  '#007697': 'rgba(0, 166, 204, 0.25)',
  '#6100b0': 'rgba(163, 102, 255, 0.2)',
};

export function getBenefitCardBorderColor(themeColor: string): string {
  const key = themeColor.trim().toLowerCase();
  return THEME_BORDER_BY_HEX[key] ?? `color-mix(in srgb, ${themeColor} 24%, transparent)`;
}
